// composables/usePolling.ts
import { ref, onUnmounted } from 'vue'
import { FlightService } from '@/service/FlightService/FlightService'
import { createNewBookingWithNewParticipants } from '@/utils/bookingUtils'
import useLoading from './useLoading'
import store from '@/store/BookingStore'

export function usePollingFlight<T>(
    boReference: string,
    intervalMs: number,
    shouldContinuePolling: (data: T) => boolean,
    onPollingStop?: (data: T) => void
) {
    const pollingActive = ref(true)
    let timer: ReturnType<typeof setTimeout>

    const startPolling = async (boReference: string, intervalMs: number) => {
        if (!pollingActive.value) return

        try {
            const data = await FlightService.getFlightDetails(boReference)

            if (shouldContinuePolling(data)) {
                if (data.error && data.error === 'Flight error') {
                    pollingActive.value = false
                    if (onPollingStop) onPollingStop(data)
                    store.commit('setShowFlightErrorModal', true)
                    return
                }
                timer = setTimeout(() => startPolling(boReference, intervalMs), intervalMs)
            } else {
                pollingActive.value = false
                if (onPollingStop) onPollingStop(data)
            }
        } catch (error) {
            console.error('Polling error:', error)
            timer = setTimeout(() => startPolling(boReference, intervalMs), intervalMs)
        }
    }

    startPolling(boReference, intervalMs);

    const stopPolling = () => {
        pollingActive.value = false
        clearTimeout(timer)
    }

    onUnmounted(stopPolling)

    return { stopPolling }
}
